module.exports = __webpack_public_path__ + "static/media/realestatecomau.0833e0c3.png";